import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Share2, Copy, Check } from 'lucide-react';

const ShareDialog = ({
  open,
  onOpenChange,
  accountantEmail,
  setAccountantEmail,
  copied,
  summaryText,
  onCopy,
  onGenerateLink,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-lg">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Share2 className="w-5 h-5 text-[#0A2B1D]" />
          Share with Accountant
        </DialogTitle>
        <DialogDescription>Generate a read-only link or email your financial summary</DialogDescription>
      </DialogHeader>

      <div className="space-y-4 py-4">
        <div className="bg-[#E2ECE7] rounded-sm p-4">
          <h4 className="font-medium text-[#111614] text-sm mb-2">Accountant Portal (Read-Only)</h4>
          <p className="text-xs text-[#5C6661] mb-3">Generate a secure link your accountant can use to view your books anytime.</p>
          <div className="flex gap-2">
            <Input
              type="email"
              placeholder="accountant@example.com"
              value={accountantEmail}
              onChange={(e) => setAccountantEmail(e.target.value)}
              className="text-sm"
            />
            <Button size="sm" className="bg-[#0A2B1D] hover:bg-[#254D3D] rounded-sm whitespace-nowrap" onClick={onGenerateLink} data-testid="generate-share-link-btn">
              Generate Link
            </Button>
          </div>
        </div>

        <div className="relative">
          <div className="absolute inset-0 flex items-center"><span className="w-full border-t" /></div>
          <div className="relative flex justify-center text-xs uppercase"><span className="bg-white px-2 text-gray-500">Or copy summary</span></div>
        </div>

        <div className="bg-gray-50 rounded-lg p-4 max-h-40 overflow-y-auto">
          <pre className="text-xs text-gray-700 whitespace-pre-wrap font-mono">{summaryText}</pre>
        </div>

        <Button variant="outline" className="w-full" onClick={onCopy}>
          {copied ? (<><Check className="w-4 h-4 mr-2 text-green-600" />Copied!</>) : (<><Copy className="w-4 h-4 mr-2" />Copy Summary</>)}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);

export default ShareDialog;
